import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import Select from "react-select";
// import moment from "moment";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import axios from 'axios';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import IconItem from 'components/common/icon/IconItem';
import { toast } from 'react-toastify';
import VitalSignModalMedpass from './VitalSignModalMedpass';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';

const ReportsNotification = () => {
    const statusMap = {
        D: 'Administered',
        R: 'Refused',
        E: 'Exception',
        M: 'Missed',
        N: 'No action taken yet'
    };
    const exceptiondrpdwndata = [
        { label: 'LOA', value: '1' },
        { label: 'In Hospital', value: '2' },
        { label: 'Other', value: '3' },
        { label: 'Medications Packaged by Client', value: '4' },
        { label: 'Meds Given at Day Program', value: '5' },
        { label: 'School', value: '6' },
        { label: 'Absent from site', value: '7' },
        { label: 'No Second Staff', value: '8' },
        { label: 'Off-Site Administration', value: '9' },
        { label: 'Vacation', value: '10' },
    ];
    const [selectedExceptions, setSelectedExceptions] = useState([]);
    const [generatingReport, setGeneratingReport] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [filteredPatient, setFilteredPatient] = useState(null);
    const [filteredDrugRx, setFilteredDrugRx] = useState('');
    const [facilities] = useState(JSON.parse(localStorage.getItem('facilitiesData')));
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [rawMedPassData, setRawMedPassData] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [patientOptions, setPatientOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showImageModal, setShowImageModal] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState(null);
    const [vitalsModal, setVitalsModal] = useState(false);
    const [vitalsData, setVitalsData] = useState(null);
    const [manualNoteModal, setManualNoteModal] = useState(false);
    const [manualNoteRow, setManualNoteRow] = useState(null);
    const [manualNoteText, setManualNoteText] = useState('');
    const [savingManualNote, setSavingManualNote] = useState(false);

    const columns = [
        {
            accessorKey: 'patient',
            header: 'Patient',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        // {
        //     accessorKey: 'rx',
        //     header: 'Rx',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     }
        // },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'qty',
            header: 'Qty',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'dose',
            header: 'Dose',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'note',
            header: 'Note',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'loa_note',
            header: 'LOA Note',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'status',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'type',
            header: 'Type',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: '',
            header: 'Image',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const imageUrl = original.image;

                return (
                    <>
                        {original.image && <IconItem
                            icon={['fas', 'eye']}
                            tag="button"
                            className="btn btn-sm btn-light"
                            title="View Prescription"
                            onClick={() => {
                                // applyWatermark(imageUrl);
                                setPreviewImageUrl(imageUrl);
                                setShowImageModal(true);
                            }}
                        />}
                    </>
                );
            }
        },
        // {
        //     accessorKey: 'med_image',
        //     header: 'Med Image',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => (
        //         <img
        //             src={original.med_image}
        //             alt="Med Image"
        //             style={{ width: '50px', height: '50px' }}
        //         />
        //     )
        // },
        // {
        //     accessorKey: 'discontinue_image',
        //     header: 'Discontinue Image',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => (
        //         <img
        //             src={original.discontinue_image}
        //             alt="Discontinue Image"
        //             style={{ width: '50px', height: '50px' }}
        //         />
        //     )
        // },
        {
            accessorKey: 'administered_by',
            header: 'Administered By',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'administered_Date_Time',
            header: 'Administered Date/Time',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'vitals_signs',
            header: 'Vitals',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => (
                original.vital_signs && original.vital_signs.length > 0 && <IconItem
                    icon={['fas', 'eye']}
                    tag="button"
                    className="btn btn-sm btn-light text-danger"
                    onClick={() => {
                        setVitalsModal(true);
                        setVitalsData(original.vital_signs);
                    }}
                />
            )
        },
        {
            accessorKey: 'manual_note',
            header: 'Manual Note',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const hasNote = original.manual_note && original.manual_note.trim() !== '';
                return (
                    <IconItem
                        icon={['fas', 'edit']}
                        tag="button"
                        className={`btn btn-sm ${hasNote ? 'btn-warning text-dark' : 'btn-light'}`}
                        title={hasNote ? 'Edit Manual Note' : 'Add Manual Note'}
                        onClick={() => {
                            setManualNoteRow(original);
                            setManualNoteText(original.manual_note || '');
                            setManualNoteModal(true);
                        }}
                    />
                );
            }
        }
    ];

    useEffect(() => {
        const firstFacility = facilities && facilities[0];
        const today = new Date();
        const oneDayBefore = new Date();
        oneDayBefore.setDate(oneDayBefore.getDate() - 1);

        setSelectedFacility(firstFacility || null);
        setStartDate(oneDayBefore);
        setEndDate(new Date());
    }, [facilities]);

    const generateReport = async () => {
        if (!startDate || !endDate) {
            setError("Please select Date range.");
            return;
        }

        const payload = {
            from_date: moment(startDate).format("MM/DD/YYYY"),
            to_date: moment(endDate).format("MM/DD/YYYY"),
            exceptions: selectedExceptions.map(e => Number(e.value)),
        };

        // 🔥 CONDITIONAL PAYLOAD
        if (filteredPatient && filteredPatient.value !== 'all') {
            payload.patient_id = Number(filteredPatient.value);
        } else {
            if (!selectedFacility) {
                setError("Please select Facility.");
                return;
            }
            payload.facility_id = selectedFacility.value;
        }

        setGeneratingReport(true);
        setError("");

        try {
            const tokenStr = localStorage.getItem("accessToken");

            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/reports/get-medpass-report`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${tokenStr}`,
                    },
                    responseType: 'blob',
                }
            );

            const { blobUrl } = await createIframeReportBlobUrl(response.data);
            setIframeSrc(blobUrl);

            toast.success("Report generated successfully!");
        } catch (err) {
            console.error(err);
            setError("Failed to generate report. Please try again.");
        } finally {
            setGeneratingReport(false);
        }
    };

    const exportReport = async () => {
        if (!startDate || !endDate) {
            setError("Please select Date range.");
            return;
        }

        const payload = {
            from_date: moment(startDate).format("MM/DD/YYYY"),
            to_date: moment(endDate).format("MM/DD/YYYY"),
            facility_id: selectedFacility.value,
            is_print: 'csv'
        };

        setGeneratingReport(true);
        setError("");

        try {
            const tokenStr = localStorage.getItem("accessToken");

            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/medpass/get-medpass-history/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${tokenStr}`,
                    },
                    responseType: 'blob',
                }
            );

            const disposition = response.headers['content-disposition'];
            const filename = disposition
                ? disposition.split('filename=')[1]?.replace(/"/g, '').trim()
                : 'medpass-report.csv';

            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            URL.revokeObjectURL(url);

            toast.success("Report Exported successfully!");
        } catch (err) {
            console.error(err);
            setError("Failed to Export report. Please try again.");
        } finally {
            setGeneratingReport(false);
        }
    };



    const fetchMedPassData = async () => {
        if (!selectedFacility) return;
        setLoading(true);
        setError("");
        const payload = {
            facility_id: selectedFacility.value,
            from_date: moment(startDate).format("MM/DD/YYYY"),
            to_date: moment(endDate).format("MM/DD/YYYY")
        };
        let tokenStr = localStorage.getItem("accessToken");
        try {

            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/medpass/get-medpass-history/`,
                payload,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );
            let results = [];
            let patientSet = new Set();
            let objData = data.medpasses
            objData?.map((item) => {
                // console.log("======>",moment.tz(item.dose_given_datetime, "America/New_York").format("MM/DD/YY hh:mm A"), ">>><<<?>>>>", item.dose_given_datetime);
                results.push({
                    patient_id: item.patient_id,
                    patient: item.patient_lastname + ", " + item.patient_firstname,
                    rx: item.id,
                    drug: item.drug,
                    qty: item.dose_qty,
                    dose: moment(item.dose_date).format("MM/DD/YY") + " " + moment(item.dose_time, "HH:mm:ss").format("hh:mm A"),
                    note: item.note || '-',
                    loa_note: item.loa_hospital_note || '-',
                    status: statusMap[item.dose_status],
                    type: item.med_type == 'C' ? "Cycle" : item.med_type == 'P' ? "PRN" : "Other",
                    administered_Date_Time: item.dose_given_datetime != null ? item.dose_given_datetime : '-',
                    administered_by: item.dose_given_by_username || '-',
                    image: item.med_image,
                    discontinue_image: item.discontinue_med_image_path,
                    exception_reason: item.loa_hospital_type,
                    vital_signs: item.vital_signs,
                    medpass_id: item.id,
                    manual_note: item.manual_note || '',
                    manual_note_updated_by: item.manual_note_updated_by || '',
                    manual_note_updated: item.manual_note_updated || ''
                })
                patientSet.add(item.patient_id);
            })

            const patientOptions = [
                { value: 'all', label: "Select All" },
                ...Array.from(patientSet).map((patientId) => {
                    const patient = objData.find(item => item.patient_id === patientId);
                    return {
                        value: patientId,
                        label: `${patient.patient_lastname}, ${patient.patient_firstname}`
                    };
                })
            ];
            setPatientOptions(patientOptions);
            setRawMedPassData(results);
        } catch (err) {
            setError("Error fetching data. Please try again.");
            setTableData([]);
        } finally {
            setLoading(false);
        }
    };

    const saveManualNote = async () => {
        if (!manualNoteRow) return;
        setSavingManualNote(true);
        try {
            const tokenStr = localStorage.getItem("accessToken");
            await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/medpass/update-medpass-manual-note`,
                {
                    medpass_id: manualNoteRow.medpass_id,
                    manual_note: manualNoteText
                },
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            setRawMedPassData((prev) =>
                prev.map((entry) =>
                    entry.medpass_id === manualNoteRow.medpass_id
                        ? { ...entry, manual_note: manualNoteText }
                        : entry
                )
            );

            toast.success("Manual note updated successfully!");
            setManualNoteModal(false);
            setManualNoteRow(null);
        } catch (err) {
            console.error(err);
            toast.error("Failed to update manual note. Please try again.");
        } finally {
            setSavingManualNote(false);
        }
    };

    useEffect(() => {
        const filteredData = rawMedPassData.filter((entry) => {
            const matchPatient = filteredPatient?.value === 'all' || filteredPatient === null || Number(filteredPatient?.value) == Number(entry?.patient_id);
            const matchDrugRx =
                filteredDrugRx === '' ||
                entry.drug?.toLowerCase().includes(filteredDrugRx.toLowerCase()) ||
                String(entry.rx).includes(filteredDrugRx);

            const selectedExceptionValues = selectedExceptions.map(e => String(e.value));
            const matchException =
                selectedExceptionValues.length === 0 ||
                (entry.exception_reason !== null &&
                    selectedExceptionValues.includes(entry.exception_reason));

            return matchPatient && matchDrugRx && matchException;

            // return matchPatient && matchDrugRx;
        });
        setTableData(filteredData);
    }, [rawMedPassData, filteredPatient, filteredDrugRx, selectedExceptions]);

    const table = useAdvanceTable({
        data: tableData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <>
            <Card className="p-3 mb-3">
                <h4 className="mb-4">Medpass Report</h4>
                <Modal show={showImageModal} onHide={() => { setShowImageModal(false); setPreviewImageUrl(null); }} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Prescription Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                        {previewImageUrl ? (
                            <img
                                src={previewImageUrl}
                                alt="Prescription"
                                className="img-fluid"
                                style={{ objectFit: 'contain' }}
                            />
                        ) : (
                            <Spinner animation="border" role="status" className="text-center">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowImageModal(false)}>
                            Close
                        </Button>
                        {/* {previewImageUrl && (
                            <a
                                href={previewImageUrl}
                                download={`prescription-${Date.now()}.png`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button variant="primary">Download</Button>
                            </a>
                        )} */}
                    </Modal.Footer>
                </Modal>
                <VitalSignModalMedpass vitals={vitalsData} show={vitalsModal} onHide={() => setVitalsModal(false)} />
                <Modal
                    show={manualNoteModal}
                    onHide={() => { setManualNoteModal(false); setManualNoteRow(null); }}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Manual Note</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {manualNoteRow?.manual_note && manualNoteRow.manual_note.trim() !== '' && (
                            <div className="mb-3 text-muted fs-10">
                                {manualNoteRow.manual_note_updated_by && (
                                    <div>
                                        Last updated by: <strong>{manualNoteRow.manual_note_updated_by}</strong>
                                        {manualNoteRow.manual_note_updated && (
                                            <> on <strong>{moment(manualNoteRow.manual_note_updated, 'YYYY-MM-DD HH:mm A').format('MM/DD/YY hh:mm A')}</strong></>
                                        )}
                                    </div>
                                )}
                                {!manualNoteRow.manual_note_updated_by && manualNoteRow.manual_note_updated && (
                                    <div>Last updated on: <strong>{moment(manualNoteRow.manual_note_updated, 'YYYY-MM-DD HH:mm A').format('MM/DD/YY hh:mm A')}</strong></div>
                                )}
                            </div>
                        )}
                        <Form.Group>
                            <Form.Label>Note</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={manualNoteText}
                                onChange={(e) => setManualNoteText(e.target.value)}
                                placeholder="Enter manual note"
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => { setManualNoteModal(false); setManualNoteRow(null); }}
                            disabled={savingManualNote}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={saveManualNote}
                            disabled={savingManualNote}
                        >
                            {savingManualNote ? 'Updating...' : 'Update'}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Row className="mb-3">
                    <Col md={12}>
                        <Row>
                            <Col md={3}>
                                <Form.Label>Facility</Form.Label>
                                <ThemedSelect
                                    options={facilities}
                                    value={selectedFacility}
                                    getOptionLabel={option => option.key}
                                    getOptionValue={option => option.value}
                                    onChange={setSelectedFacility}
                                    placeholder="Select Facility"
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>Start Date</Form.Label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="MM/dd/yy"
                                    className="form-control"
                                    placeholderText="MM/DD/YY"
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>End Date</Form.Label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="MM/dd/yy"
                                    className="form-control"
                                    placeholderText="MM/DD/YY"
                                />
                            </Col>
                            <Col md={3} className="d-flex align-items-end">
                                <Button onClick={fetchMedPassData} className="w-100">
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12} className='mt-3 mb-3'>
                        <Row>
                            <Col md={4}>
                                <Form.Label>Patient</Form.Label>
                                <ThemedSelect
                                    options={patientOptions}
                                    value={filteredPatient}
                                    onChange={setFilteredPatient}
                                    placeholder="Select Patient"
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label>Drug / Rx</Form.Label>
                                <Form.Control
                                    placeholder="Search by Drug or RX"
                                    value={filteredDrugRx}
                                    onChange={(e) => {
                                        setFilteredDrugRx(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label>Exception Reason</Form.Label>
                                <Select
                                    options={exceptiondrpdwndata}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    value={selectedExceptions}
                                    onChange={setSelectedExceptions}
                                    placeholder="Select Exception Reason(s)"
                                    classNamePrefix="react-select"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col className="d-flex gap-2">
                        <Button
                            variant="primary"
                            onClick={generateReport}
                            disabled={generatingReport}
                        >
                            Generate E-MedPass
                        </Button>
                        <Button
                            className="w-auto"
                            variant="primary"
                            onClick={exportReport}
                            disabled={generatingReport}
                        >
                            Export CSV
                        </Button>
                    </Col>
                </Row>
                <div style={{
                    height: 0,
                    overflow: 'hidden',
                    // width: 0,
                }}>
                    {iframeSrc && (
                        <iframe
                            src={iframeSrc}
                            style={{ width: "100%", height: "1000px", border: "none" }}
                            title="Preview Content"
                        />
                    )}
                </div>
            </Card>
            {loading ? (
                <ShimmerUI />
            ) : error ? (
                <Alert variant="danger">{error}</Alert>
            ) : tableData.length === 0 ? (
                <Alert variant="info">No data available for the selected filters.</Alert>
            ) : (
                <AdvanceTableProvider {...table}>
                    <Card className="p-3">
                        <Card.Body>
                            <Row>
                                <Col xs="12" className="mb-1 mt-1">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-10 mb-0 overflow-hidden'
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <div className="mt-3">
                                <AdvanceTableFooter
                                    rowInfo
                                    navButtons
                                    rowsPerPageSelection
                                />
                            </div>
                        </Card.Footer>
                    </Card>
                </AdvanceTableProvider>
            )}
        </>
    )
}

export default ReportsNotification